import dayjs from "dayjs"
import { useCallback, useMemo } from "react"
import { useSelector } from "react-redux"

import { DATE_FORMATS_OBJ } from "../containers/TeamManagementPage/constants/date-formats.ts"
import { type RootState } from "../store.ts"
import { DATE_FORMAT } from "../utils/date/date.ts"

const formatEventDate = (
  isoUtc: string | Date | null | undefined,
  timezone: string,
  dateFormat: string
): string => dayjs.utc(isoUtc).tz(timezone).format(dateFormat)

const useDateFormatter = () => {
  const userInfo = useSelector((state: RootState) => state.auth?.userInfo)

  const { timezone, dateFormat } = useMemo(() => {
    const tz = userInfo?.timezone || "UTC"
    const formatId = userInfo?.date_format
    const format = formatId ? DATE_FORMATS_OBJ[formatId]?.format : DATE_FORMAT

    return { timezone: tz, dateFormat: format }
  }, [userInfo?.timezone, userInfo?.date_format])

  const formatDate = useCallback(
    (date: string | Date | null | undefined, format?: string) => {
      if (!date) return date
      return formatEventDate(date, timezone, format ?? `${dateFormat} HH:mm`)
    },
    [timezone, dateFormat]
  )

  return { formatDate, timezone, dateFormat }
}

const selectDateFormatSettings = (state: RootState) => {
  const userInfo = state.auth?.userInfo
  const timezone = userInfo?.timezone || "UTC"
  const dateFormatId = userInfo?.date_format
  const dateFormat = dateFormatId
    ? DATE_FORMATS_OBJ[dateFormatId]?.format
    : DATE_FORMAT

  return { timezone, dateFormat }
}

export { selectDateFormatSettings, useDateFormatter }
